import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Lock, Mail, ArrowRight } from "lucide-react";
import { useAuth } from "../lib/auth";
import { ASSETS } from "../data/tournament";

const AdminLogin = () => {
  const { user, login, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  if (loading) return null;
  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const result = await login(email.trim(), password);
    setSubmitting(false);
    if (result.ok) {
      navigate("/admin", { replace: true });
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center p-6 relative overflow-hidden" data-testid="admin-login-page">
      <div className="absolute inset-0 diagonal-stripes opacity-40 pointer-events-none" />

      <div className="relative w-full max-w-md">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <img src={ASSETS.logo} alt="Coupe CH" className="h-16 w-16 object-contain" />
          <div>
            <div className="font-display text-3xl tracking-wider">COUPE CH</div>
            <div className="text-[10px] tracking-[0.3em] text-white/60 uppercase">Panneau Admin</div>
          </div>
        </div>

        <form onSubmit={onSubmit} className="bg-[#111] border border-white/10 p-8 clip-jersey" data-testid="admin-login-form">
          <span className="font-condensed uppercase tracking-[0.3em] text-xs text-[#E60012]">Connexion</span>
          <h1 className="mt-2 font-display text-3xl uppercase leading-none">Espace organisateur</h1>
          <p className="mt-3 text-white/60 text-sm">Saisissez vos identifiants pour gérer les scores et les nouvelles.</p>

          <div className="mt-6 space-y-4">
            <label className="block">
              <span className="font-condensed uppercase tracking-[0.2em] text-xs text-white/60">Courriel</span>
              <div className="mt-1 flex items-center gap-2 bg-black border border-white/10 px-3 py-2.5 focus-within:border-[#E60012]">
                <Mail className="w-4 h-4 text-white/40" />
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="admin-email-input"
                  className="flex-1 bg-transparent outline-none text-white placeholder:text-white/30"
                  placeholder="admin@coupech.ca"
                />
              </div>
            </label>

            <label className="block">
              <span className="font-condensed uppercase tracking-[0.2em] text-xs text-white/60">Mot de passe</span>
              <div className="mt-1 flex items-center gap-2 bg-black border border-white/10 px-3 py-2.5 focus-within:border-[#E60012]">
                <Lock className="w-4 h-4 text-white/40" />
                <input
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  data-testid="admin-password-input"
                  className="flex-1 bg-transparent outline-none text-white"
                  placeholder="••••••••"
                />
              </div>
            </label>
          </div>

          {error && (
            <div className="mt-4 text-sm text-red-400 border border-red-400/30 bg-red-500/10 px-3 py-2" data-testid="admin-login-error">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit"
            className="mt-6 w-full inline-flex items-center justify-center gap-3 px-6 py-3 bg-[#E60012] hover:bg-[#ff1a30] disabled:opacity-50 text-white font-condensed uppercase tracking-[0.2em] text-sm transition-all hover:-translate-y-0.5 clip-tab"
          >
            {submitting ? "Connexion…" : "Se connecter"}
            <ArrowRight className="w-4 h-4" />
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
